import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import { ChevronDown } from "@livingdesign/icons";
import {
  Divider,
  Grid,
  GridColumn,
} from "@livingdesign/react";
import { titleCase } from "../../../../helpers/utils";
import InvoiceLineItemsStyles from "./InvoiceLineItems.styles";
import { LINE_ITEM_RULE_ENGINE_WARNING_PANEL_KEY, PREVALIDATION_LINE_ITEM_LEVEL_MSGS } from "../../../../constants/constants";

const LineItemRuleResultPopOver = (props) => {
  const { lineItemRuleResults } = props;
  const classes = InvoiceLineItemsStyles()
  const ruleEngineResult = lineItemRuleResults?.ruleEngineResult || {};
  const sortedPrevalidation = lineItemRuleResults?.preValidationRuleEngineResult && lineItemRuleResults?.preValidationRuleEngineResult.sort((a, b) => b.validationTs - a.validationTs);
  return (
    <>
      <div className={classes.warning}>
        {ruleEngineResult && Object.keys(ruleEngineResult)?.map((item, index) => {
          return (
            LINE_ITEM_RULE_ENGINE_WARNING_PANEL_KEY.includes(item?.toLowerCase()) && (
              <Accordion defaultExpanded={true} elevation={0}>
                <AccordionSummary expandIcon={<ChevronDown />}>
                  <div className={classes.groupHeading}>
                    {titleCase(item?.split("_")?.join(" "))}
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid>
                    {ruleEngineResult[item]?.map((item, index) => {
                      return (
                        <>
                          <GridColumn
                            lg={12}
                            className={classes.groupMessage}
                            key={item}
                          >
                            {item}
                          </GridColumn>
                          <Divider
                            className={classes.ruleEngineDivider}
                          />
                        </>
                      );
                    })}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )
          );
        })}
      </div>
      <div className={classes.warning}>
        <div>
          {sortedPrevalidation?.[0] && Object.keys(sortedPrevalidation?.[0])?.map((item, index) => {
            return (
              (PREVALIDATION_LINE_ITEM_LEVEL_MSGS?.includes(item?.toLowerCase())) && <Accordion defaultExpanded={true} elevation={0}>
                <AccordionSummary expandIcon={<ChevronDown />}>
                  <div className={classes.groupHeading}>
                    {titleCase(item?.split("_")?.join(" "))}
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid>
                    {sortedPrevalidation?.[0]?.[item]?.map((item, index) => {
                      return (
                        <>
                          <GridColumn
                            lg={12}
                            className={classes.groupMessage}
                            key={item}
                          >
                            {item}
                          </GridColumn>
                          <Divider
                            className={classes.ruleEngineDivider}
                          />
                        </>
                      );
                    })}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default LineItemRuleResultPopOver;
